export default __webpack_public_path__ + "static/media/Profile.160d7765.png";